<header
  class="w-full h-[54px] md:h-[64px] flex items-center justify-between px-2 md:px-6 py-3 shadow-sm bg-white"
>
  <div class="flex items-center md:gap-2">
    <button
      matIconButton
      aria-label="Open menu"
      class="!flex lg:!hidden items-center justify-center"
      (click)="openSidebar()"
    >
      <mat-icon>menu</mat-icon>
    </button>
    <button matButton aria-label="Go to home" (click)="navigateToHome()">
      <img
        src="/icons/ovino-logo.svg"
        alt="Ovino logo"
        width="92"
        height="20"
        class="w-[92px] h-[20px] md:w-auto md:h-auto"
      />
    </button>
    <button
      class="hidden md:flex items-center cursor-pointer text-[length:var(--ov-body-font-size)] text-[var(--ov-text-color)]"
      onkeypress="null"
      (click)="openLocationChangeDialog($event)"
    >
      <img src="/icons/location.svg" class="mr-1" alt="Location icon" />
      @if (selectedCity() && selectedPincode()) {
        <span class="font-bold text-[length:var(--ov-body-font-size)] text-[var(--ov-text-color)]"
          >{{ stringEnum.TO }}: {{ selectedCity() }}–{{ selectedPincode() }}</span
        >
      }
      <mat-icon>{{ utilityEnum.EXPAND_MORE_MAT_ICON }}</mat-icon>
    </button>
  </div>

  <div class="navbar-actions flex items-center space-x-4">
    <!-- <button matButton="filled" color="accent" aria-label="Login or join free trial">
      {{ stringEnum.JOIN_FREE_TRIAL }}
    </button> -->
    <a
      [routerLink]="routeEnum.PRODUCTS"
      class="hidden lg:block font-bold text-[length:var(--ov-body-font-size)] text-[var(--ov-text-color)]"
      >{{ stringEnum.PRODUCTS }}</a
    >
    <a
      [routerLink]="routeEnum.GOOD_MOOD_BLOG"
      class="hidden lg:block font-bold text-[length:var(--ov-body-font-size)] text-[var(--ov-text-color)]"
      >{{ stringEnum.GOOD_MOOD_BLOG }}</a
    >
    @if (featureToggles().farmVisitEnabled) {
      <a
        [routerLink]="routeEnum.OUR_FARM"
        class="hidden lg:block font-bold text-[length:var(--ov-body-font-size)] text-[var(--ov-text-color)]"
        >{{ stringEnum.OUR_FARM }}</a
      >
    }
    <a
      [routerLink]="routeEnum.ABOUT_US"
      class="hidden lg:block font-bold text-[length:var(--ov-body-font-size)] text-[var(--ov-text-color)]"
      >{{ stringEnum.ABOUT_US }}</a
    >
    <!-- @if (isLoggedIn()) {
    <div class="flex bg-[var(--ov-background-light-blue)] py-[4px] px-[9px] rounded-[9999px] mr-1">
      <img src="/icons/bottle.svg" alt="Bottle icon" />
      <span class="font-bold ml-3 text-[var(--ov-text-color)] text-[length:var(--ov-body-font-size)]">5</span>
    </div>
    } -->
    <button
      matIconButton
      aria-label="Open shopping cart"
      (click)="openCart()"
      [ngClass]="{ 'mr-0': isLoggedIn() }"
    >
      <div class="relative inline-block">
        <mat-icon class="material-icons-outlined">{{
          utilityEnum.SHOPPING_CART_MAT_ICON
        }}</mat-icon>
        @if (cartItemCount() > 0) {
          <div
            class="absolute -top-2 -right-2 text-[10px] leading-none bg-[var(--ov-danger-text-color)] text-[var(--ov-background-white)] font-bold rounded-[9999px] text-[length:10px] w-[18px] h-[18px] z-10 flex items-center justify-center"
          >
            {{ cartItemCount() }}
          </div>
        }
      </div>
    </button>
    @if (!isLoggedIn()) {
      <button
        matButton="filled"
        color="primary"
        class="login-btn"
        [aria-label]="stringEnum.LOGIN + ' / ' + stringEnum.SIGNUP"
        (click)="openLoginSignupDialog()"
      >
        {{ stringEnum.LOGIN + ' / ' + stringEnum.SIGNUP }}
      </button>
    }
    @if (isLoggedIn()) {
      <button matIconButton aria-label="Open user profile" (click)="openUserProfile()">
        <mat-icon class="material-icons-outlined">{{ utilityEnum.USER_PROFILE_MAT_ICON }}</mat-icon>
      </button>
    }
  </div>
</header>

<!-- Main Navigation Sidebar (Hamburger Menu) -->
@if (hamburgerMenuVisible()) {
  <app-sidebar
    [navItems]="sidebarNavItems"
    [showLocation]="true"
    [selectedCity]="selectedCity()"
    [selectedPincode]="selectedPincode()"
    [locationLabel]="stringEnum.TO"
    [showFollowUs]="true"
    [socialIcons]="sidebarSocialIcons"
    [showHelpLegal]="true"
    [helpLegalItems]="sidebarHelpLegalItems"
    [closeOnNavigation]="true"
    (closeSidebar)="onSidebarClose()"
    (navItemClick)="onNavItemClick($event)"
    (locationClick)="onSidebarLocationClick($event)"
  />
}

<!-- Profile Sidebar (User Profile Menu) -->
@if (profileSidebarVisible()) {
  <app-sidebar
    [navItems]="profileSidebarNavItems"
    [position]="'right'"
    [showLocation]="false"
    [showUserProfile]="true"
    [userName]="userName()"
    [userPhone]="contactNo()"
    [showWalletBalance]="true"
    [walletBalance]="walletBalance()"
    [walletLabel]="stringEnum.BALANCE"
    [showLogout]="true"
    [showFollowUs]="false"
    [showHelpLegal]="false"
    [closeOnNavigation]="true"
    (closeSidebar)="onProfileSidebarClose()"
    (navItemClick)="onProfileNavItemClick($event)"
    (editProfileClick)="onEditProfileClick()"
    (logoutClick)="onLogoutClick()"
  />
}
